import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import { LINKS } from 'constants/menus';
import { UtilitySidebar, UtilitySideBarItem } from 'components/Layouts';

const Sidebar = () => {
  const navigate = useNavigate();

  return (
    <UtilitySidebar>
      {[{ icon: <ArticleOutlinedIcon />, label: 'Document Templates', link: LINKS.SUPER_ADMIN.DOCUMENT_TEMPLATES }].map(({ icon, label, link }, i) => (
        <NavLink style={{ width: '100%' }} key={`super-admin-link-${i}`} to={link}>
          {({ isActive }) => <UtilitySideBarItem onClick={() => navigate(link)} active={isActive} icon={icon} label={label} />}
        </NavLink>
      ))}
    </UtilitySidebar>
  );
};

export default Sidebar;
